import React from 'react'

export default function Map() {
  return (
    <>
      <iframe style={{ width: '100%', height: 350 }} frameborder="0" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas" src="https://maps.google.com/maps?width=1920&amp;height=400&amp;hl=en&amp;q=GBI%20Kalvari%20Cirebon+(GBI%20Kalvari)&amp;t=&amp;z=17&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe>  <script type='text/javascript' src='https://embedmaps.com/google-maps-authorization/script.js?id=e3c9ba949fdc0f5004eaf958c16841dc4dd0fc30'></script>
    </>
  )
}
